import React from 'react'
import RecordForm from '../../../../../../generic/universal-table/components/RecordForm/RecordForm'
import { PackageUiRow } from '../types/packageTable.types'

type PackageFormProps = React.ComponentProps<typeof RecordForm<PackageUiRow>>

// Thin module-named wrapper so AppModal has a stable `Children` seam (and a place for
// any future package-specific glue). All logic lives in the unified RecordForm.
const PackageForm = (props: PackageFormProps) => <RecordForm<PackageUiRow> {...props} />

export default PackageForm
